import { render, staticRenderFns } from "./addSegment.vue?vue&type=template&id=37971316&lang=pug"
import script from "./addSegment.vue?vue&type=script&lang=js"
export * from "./addSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports